module.exports = __webpack_public_path__ + "assets/e1688fdf46d08e782078ab1a46de342e.mp3";